export const UPDATE_PERMISSION = `
  mutation updatePermission($input:  UpdatePermissionInput!) {
    updatePermission(input: $input) {
      __typename
      ... on Permissions {
        id
        name
        code
        description 
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
